(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$scope', '$rootScope', '$state', 'entity', 'Principal', 'User', 'Profile', 'Education', 'Position', 'Picture', 'Dashboard'];

    function ProfileController($scope, $rootScope, $state, entity, Principal, User, Profile, Education, Position, Picture, Dashboard) {

        var vm = this;
        vm.profile = entity;
        loadPicture(vm.profile);
        vm.picture;
        vm.currentAccount;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });



        vm.educations = vm.profile.educations ? vm.profile.educations : [];
        vm.currentPosition = vm.profile.currentPosition;
        vm.positions = vm.profile.positions ? vm.profile.positions : [];
        vm.isStatOpen = false;
        vm.statMode = 'rank';
        vm.lineOptions = {
            legend: { display: true },
            elements : { line : { tension : 0 } }
        };
        vm.barOptions = {
            legend: { display: true }
        };
        vm.series = {
            ranks: ['Classement'],
            rates: ['Note'],
            deals: ['Deals'],
            contributions: ['Créations', 'Modifications', 'Alertes'],
            network: ['Rang 1', 'Rang 2', 'Rang 3']
        };
        vm.rankColors = [{
            backgroundColor: "rgb(166,210,253)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];
        vm.rateColors = [{
            backgroundColor: "transparent",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "rgb(117,151,184)",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];
        vm.dealColors = [{
            backgroundColor: "rgb(166,210,253)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "rgb(117,151,184)",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];
        vm.contributionColors = [{
            backgroundColor: "rgb(117, 151, 184)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        },{
            backgroundColor: "rgb(157, 190, 224)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        },{
            backgroundColor: "rgb(166, 210, 253)",
            pointBackgroundColor: "transparent",
            pointHoverBackgroundColor: "transparent",
            borderColor: "transparent",
            pointBorderColor: "transparent",
            pointHoverBorderColor: "transparent"
        }];

        vm.statsAccount = {
            position: {
                count: 16,
                rate: 3
            },
            deals: {
                count: 5,
                rate: 0
            },
            contributions: {
                count: 16,
                rate: -5
            },
            network: {
                count: 0,
                rate: 0
            },
            networkWithGrade3: {
                count: 0,
                rate: 0
            }
        };

        //computeProgressBarWidth();
        init();

        function init(){
            Dashboard.get().then(function (data) {
                vm.statsAccount.networkWithGrade3.count = data.myNetworkWithGrade3;
                vm.statsAccount.network.count = data.myNetwork;
                vm.statsAccount.aConnecterCount = data.aConnecter;
            })
        }



        function computeProgressBarWidth() {
            var aKeys = ['position', 'deals', 'contributions', 'indices'];
            var aMax = 0;
            aKeys.forEach(function (key) {
                if (vm.statsAccount[key].count > aMax) {
                    aMax = vm.statsAccount[key].count;
                }
            });
            if (aMax === 0) {
                aKeys.forEach(function (key) {
                    vm.statsAccount[key].width = 50;
                });
            } else {
                aKeys.forEach(function (key) {
                    if (key === 'position') {
                        vm.statsAccount[key].width = 50 + 50 * Math.max((20 - vm.statsAccount[key].count) / 20, 0);
                    } else {
                        vm.statsAccount[key].width = 50 + 50 * vm.statsAccount[key].count / aMax;
                    }
                });
            }
        }

        vm.statLabels = ['07/2016', '08/2016', '09/2016', '10/2016', '11/2016', '12/2016',
                    '01/2017', '02/2017','03/2017','04/2017','05/2017','06/2017'];
        vm.stats = {
            ranks: [[32,25,28,22,24,25,18,18,15,10,12,11]],
            rates: [[7,7.12,7.6,7.5,7.8,7.9,8.2,8.6,8.8,8.81,8.88,8.99]],
            deals: [[1,4,3,5,1,4,3,2,4,1,4,3]],
            contributions: [[1,3,3,4,2,1,5,3,4,3,2,1],
                [1,4,5,1,3,3,4,1,2,3,4,3],
                [1,4,3,2,1,2,3,1,0,3,1,2]],
            network: [[1,3,5,5,2,1,4,3,1,0,2,1],
                [1,3,4,4,5,4,5,4,3,2,3,3],
                [3,3,2,1,4,4,3,2,4,1,4,2]]
        }

        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture = response;
                    vm.picture = response;
                }, function (response) {
                    console.log(response);
                });
            }
        }

    }
})();
